export type ImpactStrength = "none" | "low" | "medium" | "high";

/**
 * Classify a ±100 impact score into a strength level.
 *
 * Brackets (absolute value after rounding):
 *   0        → none
 *   1–24     → low
 *   25–49    → medium
 *   50–100   → high
 */
export function getImpactStrength(score: number): ImpactStrength {
  const abs = Math.abs(Math.round(score));
  if (abs === 0) return "none";
  if (abs <= 24) return "low";
  if (abs <= 49) return "medium";
  return "high";
}
